import React, { FunctionComponent } from "react";
import { IIconProps } from "./icon";

export const MenuIcon: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg viewBox="0 0 36 36" {...rest}>
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="UI-Elements/Base/Header-Mobile" transform="translate(-316.000000, -56.000000)">
          <g id="Group" transform="translate(316.000000, 56.000000)">
            <rect id="Rectangle-Copy" fill="#82BECC" x="0" y="0" width="36" height="36" rx="8"></rect>
            <g
              transform="translate(6.000000, 6.000000)"
              id="Overrides/Icons/Menu"
              stroke="#FFFFFF"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            >
              <g>
                <line x1="4" y1="12" x2="20" y2="12" id="Line-2"></line>
                <line x1="4" y1="6" x2="20" y2="6" id="Line-2-Copy-2"></line>
                <line x1="4" y1="18" x2="20" y2="18" id="Line-2-Copy"></line>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
